import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ErrorMessage = ({ customMessage, message, className }) => {
  return customMessage ? (
    <div
      className={`text-xs text-red-500 animate-slidedown lg:mt-1 w-full ${className}`}
    >
      {customMessage}
    </div>
  ) : (
    <p
      className={`text-xs text-red-500 animate-slidedown lg:mt-1 w-full ${className}`}
    >
      {message}
    </p>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string,
  customMessage: PropTypes.node,
  className: PropTypes.string,
};
ErrorMessage.defaultProps = {
  message: null,
  className: 'mt-1',
};

export default memo(ErrorMessage);
